import { Box, styled } from '@mui/material';
import { spaceCadet } from '../../../../../utils/colors';

const StyledBox = styled(Box)({
  borderBottom: `1px solid ${spaceCadet[300]}`,
});

export default StyledBox;
